import { Box, Typography } from '@mui/material';

import ProductCard from '../card/ProductCard';
import { Fragment, useEffect, useState } from 'react';
import { getAllProducts } from '../../apiCalls/urlFunction';


const SmilarGiftSectionComponent = (props) => {
  const [similarProduct, setSimilarProduct] = useState([]);

  const GetSimilarProuctData = async () => {
    const response = await getAllProducts({ BrandId: props?.sectionData })
    setSimilarProduct(response?.data?.edges)
  }

  useEffect(() => {
    GetSimilarProuctData()
  }, [])

  return (
    <Fragment>
      {props?.sectionTitle && (
        <Typography
          sx={{
            color: "primary.main",
            fontFamily: "Be Vietnam Pro",
            textTransform: 'capitalize',
            fontWeight: 500,
            fontSize: { xs: '16px', sm: '24px', md: '30px' },
          }}
        >
          {props?.sectionTitle}
        </Typography>
      )}
      <Box
        sx={{
          display: "grid",
          justifyContent: {
            xs: "center",
            md: "unset",
          },
          gridTemplateColumns: {
            xs: "repeat(2, 160px)",
            sm: "repeat(3, 210px)",
            md: "repeat(3, 230px)",
            lg: "repeat(4, 1fr)",
          },
          gap: {
            xs: 1,
            sm: 1,
            md: 3,
          },
        }}
      >

        {similarProduct?.slice(0, 8).map((item) => (
          <ProductCard
            key={item?.id || Math.random()}
            data={item}
            categoryTitle={props?.sectionTitle}
          />
        ))}
      </Box>
    </Fragment>
  )
}

export default SmilarGiftSectionComponent;
